import { keyBy, reduce } from "lodash"
import { theme } from "twin.macro"

export const PENDING = "Pending"
export const ACTIVE = "Active"
export const INACTIVE = "Inactive"

export const INVITE_STATUSES = [
    {
        key: PENDING,
        label: PENDING,
        color: theme`colors.orange600`,
        bg: theme`colors.orange200`
    },
    {
        key: ACTIVE,
        label: ACTIVE,
        color: theme`colors.teal600`,
        bg: theme`colors.teal200`
    },
    {
        key: INACTIVE,
        label: INACTIVE,
        color: theme`colors.gray600`,
        bg: theme`colors.gray200`
    }
]

export const INVITE_STATUS_MAP = keyBy(INVITE_STATUSES, "key")
export const INVITE_STATUS = reduce(
    INVITE_STATUSES,
    (acc, crr) => ({ ...acc, [crr.key.toUpperCase()]: crr.key }),
    {}
)
